import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppDownloadComponent } from './appdownload.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [AppDownloadComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
    ]
})
export class AppDownloadModule { }
